// Access / credentials / data signals per DevOps ticket, for the work item row
// tags (Patrick, 2026-10-01). Fetched ONCE per session for Patrick, Eric and
// Walker (auth/readyAccess.js) from the same ledger and the same function as
// Ready for me (/work/ready); everyone else never calls it and sees nothing.
import { createContext, createElement, useContext, useEffect, useState } from 'react';
import { getUser } from '../auth/authService';
import { isReadyUser } from '../auth/readyAccess';
import { getAccessSignals } from './workService';

// status: 'off' (not a viewer), 'loading', 'ok', 'error'
const Ctx = createContext({ status: 'off', signals: {} });

export function AccessSignalsProvider({ children, load = getAccessSignals, who = getUser }) {
    const [value, setValue] = useState({ status: 'off', signals: {} });
    useEffect(() => {
        let live = true;
        who().then((u) => {
            if (!isReadyUser(u?.profile)) return;
            setValue({ status: 'loading', signals: {} });
            return load()
                .then((r) => live && setValue({ status: 'ok', signals: r?.signals || {} }))
                .catch(() => live && setValue({ status: 'error', signals: {} }));
        }).catch(() => {});
        return () => { live = false; };
    }, [load, who]);
    return createElement(Ctx.Provider, { value }, children);
}

export const useAccessSignals = () => useContext(Ctx);
export const AccessSignalsContext = Ctx;
